module.exports = __webpack_public_path__ + "img/sticker_9.bec92495.svg";